import React, { useState, useEffect, useCallback, useRef } from 'react';
import styles from 'components/app-message/index.module.sass';
import classname from 'classnames/bind';
import iconSuccess from 'assets/icon_hint_success.svg';
import iconFailure from 'assets/icon_hint_failure.svg';

const cx = classname.bind(styles);

/**
 * @param type ('success'|'failure')
 * @param isShow (boolean)
 * @param autoDismiss (boolean)
 * @param onDismiss (function)
 * @param children
 */

const AppMessage = ({ type = '', isShow = true, autoDismiss = true, onDismiss = () => {}, children }) => {
  let dismissTimeoutHandler = useRef();
  const IconImg = ({ type }) => {
    switch (type) {
      case 'success':
        return <img width={60} src={iconSuccess} alt="icon" />;
      case 'failure':
        return <img width={60} src={iconFailure} alt="icon" />;
      default:
        return <div />;
    }
  };

  const [show, setShow] = useState(isShow);
  const dismissHandler = useCallback(() => {
    if (autoDismiss) {
      clearTimeout(dismissTimeoutHandler.current);
      setShow(false);
      onDismiss();
    }
  }, [onDismiss, autoDismiss]);

  useEffect(() => {
    setShow(isShow);
  }, [isShow]);

  useEffect(() => {
    if (show && autoDismiss) {
      dismissTimeoutHandler.current = setTimeout(dismissHandler, 3000);
    }
  }, [show, dismissHandler, autoDismiss]);

  const appMessageClasses = cx({
    'app-message': true,
    [type]: true,
    show,
  });

  return (
    <div className={appMessageClasses} onClick={dismissHandler}>
      <IconImg type={type} />
      {children}
    </div>
  );
};

export default AppMessage;
